.aiHeader {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.aiHeaderText {
    display: flex;
    flex-direction: column;
}

.aiHeaderButtons {
    display: flex;
    flex-direction: row;
    gap: 10px;
}

.iconAndStatusContainer {
    margin-bottom: 12px;
}

.green {
    color: var(--hps-dark-green);
}

.red {
    color: var(--hps-red);
}

.list {
    color: var(--hps-blue);
    padding-left: 16px;
}

.marginTop {
    margin-top: 50px;
}

.disclaimer {
    margin-top: 10px;
}

.titleAndTooltipContainer {
    display: flex;
    gap: 5px;
}

.tooltipForControl {
    /* This value was obtained through trial and error. The header and tooltip don't seem to play well together--in fact, it may be that one or both of those components needs to be updated across the app, at which point this styling may become obsolete. */
    margin-top: -4px;
}

.tooltipForComplianceRequirement  {
    /* This value was obtained through trial and error. The header and tooltip don't seem to play well together--in fact, it may be that one or both of those components needs to be updated across the app, at which point this styling may become obsolete. */
    margin-top: -8px;
}